module.exports = __webpack_public_path__ + "static/img_9346-4988f5b295b2ecf2c32d9b4a7592b5c6.webp";